import React from 'react'
import InputSelectAsync from '../InputSelectAsync'
import { fetchCriterionOptions } from 'services/options_services'

const CriterionInputAsync = (props) => (
    <InputSelectAsync
        defaultOptions
        loadOptions={(search) => fetchCriterionOptions({ search, page_size: 30 })}
        getOptionValue={(d) => d.id}
        getOptionLabel={(d) => d.name}
        {...props}
    />
)

export default CriterionInputAsync
